<template>
  <v-form ref="form" v-model="valid" :lazy-validation="true">
    <v-card>
      <div class="message-form__content">
        <v-card-title>
          <span class="headline">{{ titlePrefix }} Item Group</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            name="itemname"
            label="Name (Shown on Z-report and customer's receipt)"
            v-model="ownItem.name"
            :rules="stringValidation"
          />

          <v-select
            name="vat"
            label="Vat (%)"
            v-model="ownItem.vat"
            :rules="vatValidation"
            :items="['25','12','6','0']"
          />
        </v-card-text>
      </div>
      <v-card-actions>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" @click="submit">Save</v-btn>
        <v-btn text @click="cancel" color="primary" :disabled="isSaving">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      vatValidation: [
        v => !!v || 'Cannot be empty',
        v => !Number.isNaN(Number(v)) || 'Must be a number',
        v => v >= 0 || 'Can\'t be negative'
      ],
      ownItem: {}
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['itemgroups.create', 'itemgroups.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);
      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel')
    },
    reset () {
      this.setOwnItem(null);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
